import { render, staticRenderFns } from "./Tmp.vue?vue&type=template&id=3c23ade4"
import script from "./Tmp.vue?vue&type=script&lang=js"
export * from "./Tmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports